"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontSizeCalc = exports.sizeCalc = void 0;
var BASE_UNIT = 'px';
var BASE_FONT_UNIT = 'px';
var BASE_FONT_SIZE = 16;
function sizeCalc(size, fontSize) {
    if (fontSize === void 0) { fontSize = BASE_FONT_SIZE; }
    if (BASE_UNIT === 'px') {
        return "".concat(size, "px");
    }
    var calculatedSize = size / fontSize;
    return "".concat(calculatedSize).concat(BASE_UNIT);
}
exports.sizeCalc = sizeCalc;
function fontSizeCalc(size) {
    if (BASE_FONT_UNIT === 'px') {
        return "".concat(size, "px");
    }
    var calculatedSize = size / BASE_FONT_SIZE;
    return "".concat(calculatedSize).concat(BASE_FONT_UNIT);
}
exports.fontSizeCalc = fontSizeCalc;
